import Vue from 'vue'
import App from './App.vue'
import BootstrapVue from 'bootstrap-vue'
import VueTranslate from 'vue-translate-plugin';

import { library } from '@fortawesome/fontawesome-svg-core'
import {
  faCog, faReply, faPlus, faMinus, faSpinner
} from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

// Load SCSS file directly using Sass Loader
import "@/scss/app.scss"


Vue.config.productionTip = false

// Prepare FontAwesome icons for use in app
// Import and add to library only icons that will actually be used
library.add(faCog, faReply, faPlus, faMinus, faSpinner)

// Register components globally in app
Vue.component('font-awesome-icon', FontAwesomeIcon);

// Tell Vue to use defined libraries
Vue.use(BootstrapVue)

// Translate text in app
Vue.use(VueTranslate);Vue.locales({
  da_DK: {
    'You can pick as many as you like': 'Du kan vælge så mange du vil'
  }
});

// Create a Vue instance
new Vue({
  render: h => h(App),
}).$mount('#app')
